import { render, staticRenderFns } from "./AuditClaimsTab.vue?vue&type=template&id=64a4314a&scoped=true"
import script from "./AuditClaimsTab.vue?vue&type=script&lang=js"
export * from "./AuditClaimsTab.vue?vue&type=script&lang=js"
import style0 from "./AuditClaimsTab.vue?vue&type=style&index=0&id=64a4314a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4314a",
  null
  
)

export default component.exports